import decodeJWT from 'jwt-decode'
import { getUserName } from '../helpers/decode-username'
import { AUTH_SUCCESS,
  AUTH_FAILURE,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  LOGOUT,
  ACCEPT_TERMS_SUCCESS,
  UNREAD_NOTIFICATIONS_SUCCESS,
  READ_IN_PROGRESS_NOTIFICATIONS_SUCCESS,
  READ_ISSUE_NOTIFICATIONS_SUCCESS,
  INCREMENT_IN_PROGRESS_UNREAD_NOTIFICATIONS,
  INCREMENT_ISSUE_UNREAD_NOTIFICATIONS,
  LOCATION_TOTAL_ISSUES_SUCCESS } from '../actions/auth'

const defaultAuthState = {
  unreadNotification: {
    inProgress: 0,
    issue: 0
  },
  totalIssues: {
    "needs_work": 0,
    "needs_review": 0,
    "permanent": 0
  }
}

export default function (state = defaultAuthState, action) {
  switch (action.type) {
    case AUTH_SUCCESS:
      // clear previous unsuccessful attempts of log in by removing
      // name and message keys from state
      const {
        name: _name,
        message: _message,
        ...newState
      } = state

      return {
        ...newState,
        session: {
          type: action.payload.type,
          token: action.payload.token,
          email: action.payload.email,
          hasAcceptedTerms: action.payload.hasAcceptedTerms,
          userName: getUserName(action.payload.token),
          locationIds: action.payload.locationIds,
          id: action.payload.id
        }
      }

    case AUTH_FAILURE:
      return {
        ...state,
        ...action.payload
      }

    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        ...action.payload
      }

    case RESET_PASSWORD_FAILURE:
      return {
        ...state,
        ...action.payload
      }

    case LOGOUT:
      return {
        ...state,
        session: undefined
      }

    case ACCEPT_TERMS_SUCCESS:
      return {
        ...state,
        session: {
          ...state.session,
          hasAcceptedTerms: action.payload.hasAcceptedTerms
        }
      }

    case UNREAD_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        unreadNotification: action.payload.unreadNotification
      }

    case LOCATION_TOTAL_ISSUES_SUCCESS:
      return {
        ...state,
        totalIssues: action.payload.totalIssues
      }

    case READ_IN_PROGRESS_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        unreadNotification: {
          ...state.unreadNotification,
          inProgress: 0
        }
      }

    case READ_ISSUE_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        unreadNotification: {
          ...state.unreadNotification,
          issue: 0
        }
      }

    case INCREMENT_IN_PROGRESS_UNREAD_NOTIFICATIONS:
      return {
        ...state,
        unreadNotification: {
          ...state.unreadNotification,
          inProgress: state.unreadNotification.inProgress += action.incrementAmount
        }
      }

    case INCREMENT_ISSUE_UNREAD_NOTIFICATIONS:
      return {
        ...state,
        unreadNotification: {
          ...state.unreadNotification,
          issue: state.unreadNotification.issue += action.incrementAmount
        }
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js